import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import FarmerImage from '../Farmer.png';
import GeneratorImage from '../Generator.png';
import MachinaryImage from '../Machinary.png';
import LogoImage from '../logo.png';
import '../styles/History.css';

const TimelineEvent = ({ year, title, text, image, flip }) => (
  <div className={`timeline-event ${flip ? 'flip' : ''}`} aria-hidden={false}>
    <div className="timeline-card" tabIndex={0} role="group" aria-label={`${title} — ${year}`}>
      <div className="card-media" aria-hidden={image ? 'false' : 'true'}>
        {image ? (
          <img src={image} alt={title} loading="lazy" />
        ) : null}
      </div>

      <div className="card-body">
        <div className="card-header">
          <h4 className="card-title">{title}</h4>
          <div className="card-year" aria-hidden>{year}</div>
        </div>
        <p className="card-text">{text}</p>
      </div>
    </div>
  </div>
);

const History = () => {
  const location = useLocation();

  // If router pushed with { state: { scrollToTop: true } } scroll to top
  useEffect(() => {
    if (location.state?.scrollToTop) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location.state]);

  const events = [
    {
      year: '2010',
      title: 'Seed: Partnering with Farmers',
      text:
        'Afework International Group began by collaborating closely with local farmers to export high-quality agricultural produce. We built rigorous quality controls and direct supply relationships that helped farmers reach international markets.',
      image: FarmerImage,
    },
    {
      year: '2016',
      title: 'Power & Reliability — Generators',
      text:
        'Responding to local industry needs, we started importing robust generators suited to industrial and commercial environments — ensuring uninterrupted operations for our clients across sectors.',
      image: GeneratorImage,
    },
    {
      year: '2021',
      title: 'Industrial Reach — Machinery & Medical',
      text:
        'Our growth expanded into specialized imports, including advanced industrial machinery and medical equipment — partnering with trusted global manufacturers to bring cutting-edge solutions to local markets.',
      image: MachinaryImage,
    },
    {
      year: 'Today',
      title: 'The Road Ahead',
      text:
        'We continue to innovate and expand our offering — from agri exports to medical and industrial imports. Join us as we advance quality, reliability and service across the region.',
      image: LogoImage,
    },
  ];

  return (
    <main className="history-page" id="history-page" role="main">
      <div className="history-header container">
        <h1 className="history-title">Our Journey</h1>
        <p className="history-subtitle">
          From local farms to specialized imports — a timeline of our milestones and the values that drive us.
        </p>
      </div>

      <section className="timeline container" aria-label="Company timeline">
        {events.map((ev, idx) => (
          <TimelineEvent
            key={ev.year + idx}
            year={ev.year}
            title={ev.title}
            text={ev.text}
            image={ev.image}
            flip={idx % 2 === 1}
          />
        ))}
      </section>

      <section className="history-conclusion container" aria-labelledby="conclusion-title">
        <h2 id="conclusion-title">Where we are headed</h2>
        <p>
          As we reflect on our growth, we are excited about the next phase — strengthening partnerships, investing
          in technology and expanding services that bring value to our customers and communities.
        </p>

        <div className="logo-wrap" aria-hidden>
          <img src={LogoImage} alt="Afework International Group" loading="lazy" />
        </div>
      </section>
    </main>
  );
};

export default History;
